function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Rocket_svg__clip0)",
    fill: props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.35 5.65A2.221 2.221 0 0012.805 5a2.222 2.222 0 00-2.195 2.195 2.221 2.221 0 002.195 2.195c.569 0 1.138-.244 1.545-.65.894-.894.894-2.277 0-3.09zm-.65 2.44c-.489.487-1.302.487-1.79 0a1.276 1.276 0 010-1.79c.245-.243.57-.406.895-.406.325 0 .65.163.894.407.488.488.488 1.3 0 1.788zM6.382 11.179l-3.658-.732c-.407-.081-.65-.406-.732-.732 0-.406.163-.731.569-.975l4.797-2.602c.325-.162.813-.162 1.057.163l.406.406-.813.813-.325-.325-4.146 2.277 3.09.65-.245 1.057zM10.447 17.927h-.162c-.407-.081-.65-.325-.732-.732l-.732-3.658 1.138-.244.65 3.09 2.277-4.147-.325-.325.813-.813.406.406c.326.325.326.732.163 1.057l-2.601 4.797c-.244.406-.57.569-.895.569z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.065 14.106l-3.17-3.171.08-.325c.082-.163 1.464-3.821 3.822-6.016 3.17-2.927 7.805-2.927 7.967-2.927h.57v.569c0 .162-.082 4.797-2.928 7.967-2.195 2.358-5.853 3.74-6.016 3.821l-.325.082zm-1.87-3.415l2.114 2.114c.976-.407 3.577-1.626 5.285-3.415 2.032-2.195 2.52-5.366 2.601-6.585-1.22.081-4.39.569-6.585 2.602C8.82 7.033 7.602 9.715 7.195 10.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.667 18.333v-.569c.08-4.553 3.008-6.829 4.552-7.48l.163-.08.407 1.056-.163.082s-3.496 1.463-3.821 5.853c4.471-.325 5.853-3.74 5.853-3.74l.082-.162 1.057.406-.082.163c-.569 1.544-2.926 4.471-7.48 4.471h-.568z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Rocket_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.667 1.667h16.667v16.667H1.667z"
  }))));
};
SvgRocket.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgRocket.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgRocket;